/* @flow */

export type CallbackType = (value: any, index: number, array: Array<any>) => number | string

/**
 * converts mixed to array
 * @param  {mixed} mixed anything, if an array it returns the same object otherwise wraps it in an array
 * @return {Array}
 */
export const arrayWrap = (mixed: any): Array<any> => {
  return Array.isArray(mixed) ? mixed : [mixed]
}

/**
 * flatten array 1 level
 * @param  {array} arr array containings arrays to get flattened
 * @return {array}
 * @example
 * flatten([[1, 2], [3, 4]]) == [1, 2, 3, 4]
 */
export const flatten = (arr: Array<mixed>): Array<mixed> => {
  return [].concat.apply([], arr)
}

/**
 * generates an array of unique entries
 * @param  {array} arr array containing dublicates
 * @return {array}
 */
export const unique = (arr: Array<mixed>): Array<mixed> => {
  return arr.filter((value, index, self) => {
    return self.indexOf(value) === index
  })
}

/**
 * removes element from array if it exists
 * @param  {array} arr some array
 * @param  {mixed} item item of array
 * @return {array}
 */
export const remove = (arr: Array<mixed>, item: mixed) => {
  const newArr: Array<mixed> = [].concat(arr)
  const index = newArr.indexOf(item)
  if (index >= 0) newArr.splice(index, 1)
  return newArr
}

/**
 * add element to array
 * @param  {array} arr some array
 * @param  {mixed} item new item
 * @return {array}
 */
export const add = (arr: Array<mixed>, item: mixed) => {
  const newArr: Array<mixed> = [].concat(arr)
  newArr.push(item)
  return newArr
}

/**
 * groups an array by the calback
 * @param  {array} arr some array
 * @param  {function} callback some callback function
 * @return {object}
 */
export const groupBy = (array: Array<any>, callback: CallbackType) => {
  const grouped = {}
  array.forEach((currentValue, index, array) => {
    const groupKey = callback(currentValue, index, array)
    if (!grouped[groupKey]) grouped[groupKey] = []
    grouped[groupKey].push(currentValue)
  })
  return grouped
}
